// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"SelfiesTip_style_b-icon-warning__tB+-R","wrapper":"SelfiesTip_style_wrapper__9P3IP","rotate":"SelfiesTip_style_rotate__opy1d"};